import { Button, Col, DatePicker, Row } from 'antd';
import React from 'react';
import { phoneStatuses } from '../../../shared';
import { MAIN_BACKGROUND_COLOR } from '../../../styleConstants';

export default function CallNumber({ phoneList, onUpdateContactStatus }) {
  return (
    <Col
      lg={8}
      md={16}
      sm={20}
      xs={20}
      style={{
        border: '1px black solid',
        overflowX: 'hidden',

        overflowY: 'auto',
        margin: '4px',
        borderRadius: '5px',
      }}
    >
      <Row
        style={{
          borderBottom: '1px black solid',
          borderRadius: '5px',
        }}
      >
        {/* <Col style={{ padding: '10px', backgroundColor: 'brown' }} span={8}>
          <DatePicker />
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {phoneList?.length}
          </div>
        </Col> */}
        <Col span={12}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <h3>Called Number</h3>
          </div>
        </Col>
        <Col
          style={{
            backgroundColor: MAIN_BACKGROUND_COLOR,
            color: 'black',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          span={6}
        >
          Total: {phoneList?.length}
        </Col>
        <Col
          style={{
            backgroundColor: MAIN_BACKGROUND_COLOR,
            color: 'black',
            display: 'flex',
            alignItems: 'center',
          }}
          span={6}
        >
          <Button
            onClick={() => {
              // eslint-disable-next-line array-callback-return
              phoneList?.map((value, index) => {
                onUpdateContactStatus({
                  _id: value._id,
                  taskId: value.taskId,
                  status: phoneStatuses.MESSAGE_SENT,
                });
              });
            }}
          >
            Check All
          </Button>
        </Col>
      </Row>

      <Row
        gutter={[12, 12]}
        justify='center'
        align='top'
        style={{ height: '100vh', color: 'black', padding: '20px' }}
      >
        <Col span={24}>
          {phoneList?.map((value, index) => {
            return (
              <Row
                key={value.phoneNumber}
                gutter={[12, 12]}
                justify='center'
                align='middle'
                style={{ color: 'black', marginTop: '10px' }}
              >
                <Col span={2}>{index + 1}</Col>
                <Col span={9}>{value.phoneNumber}</Col>
                <Col span={7}>
                  {value.createdAt && new Date(value.createdAt).toDateString()}
                </Col>
                <Col span={6}>
                  <Button
                    onClick={() =>
                      onUpdateContactStatus({
                        _id: value._id,
                        taskId: value.taskId,
                        status: phoneStatuses.MESSAGE_SENT,
                      })
                    }
                    type={'primary'}
                    style={{ borderRadius: '50px', width: '100%' }}
                  >
                    Ok
                  </Button>
                </Col>
              </Row>
            );
          })}
        </Col>
      </Row>
    </Col>
  );
}
